import { toast } from 'react-toastify';
import axios from '../../axios';
import {
   ADD_SALE_RETURN_INVOICE,
   GET_SALE_RETURN_INVOICES,
   GET_SALE_RETURN_INVOICES_FOR_DAYBOOK,
   GET_SALE_RETURN_INVOICE,
   GET_SALE_RETURN_INVOICES_TRANSACTIONS,
   UPDATE_SALE_RETURN_INVOICE,
   DELETE_SALE_RETURN_INVOICE,
   LAST_BILL_SALE_RETURN_INVOICE,
   GET_LAST_SALE_RETURN_DAYBOOK,
   GET_ONE_SALE_RETURN,
   GET_SALE_RETURN_LINE_ITEMS,
   ADD_SALE_RETURN_LINE_ITEM,
   UPDATE_SALE_RETURN_LINE_ITEM,
   DELETE_SALE_RETURN_LINE_ITEM,
   EMPTY_ONE_SALE_RETURN,
   GET_SALE_RETURN_INVOICE_WITH_PREV_AND_NEXT,
   GET_SALE_RETURN_INVOICE_PREV_AND_NEXT,
   GET_SALES_STOCKS,
   DELETE_MULTI_SALES_RETURN_INVOICE,
} from '../types';

// ======================== SALES RETURN ========================

export const deleteMultiSalesReturnInvoice = (formData) => async (dispatch) => {
   try {
      dispatch({ type: 'SET_LOADING', payload: true });
      const res = await axios.post("/sReturn-invoice/delete/multi", formData);
      if (res.data.code === 1) {
         dispatch({ type: DELETE_MULTI_SALES_RETURN_INVOICE, payload: res.data.data });
         setTimeout(() => {
            toast.success('Sales Invoice deleted successfully!');
         }, 1000);
         return res.data;
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data?.message) {
         toast.error(err.response?.data?.message);
      }
   }
};

// Add Sale Return
export const addSaleReturnInvoice = (data) => async (dispatch) => {
   try {
      dispatch({ type: 'SET_LOADING', payload: true });
      const res = await axios.post(`/sReturn-invoice/add`, data);
      if (res.data.code === 1) {
         dispatch({
            type: ADD_SALE_RETURN_INVOICE,
            payload: {
               data: res.data.data || [],
               pagination: res.data.pagination || {},
               totalCount: res.data.totalCount || 0,
            },
         });
         setTimeout(() => {
            toast.success('Sale Return Invoice added successfully!');
         }, 1000);
         return res.data;
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
         return res.data;
      }
      return res.data;
   } catch (error) {
      if (error?.response?.data?.message) {
         toast.error(error?.response?.data?.message);
      }
      return error?.response?.data;
   }
};

export const checkDocNo = (data) => async (dispatch) => {
   try {
      const res = await axios.post('/sReturn-invoice/checkDocNo', data);
      if (res.data.code === 1) {
         return res.data;
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (error) {
      if (error?.response?.data?.message) {
         toast.error(error?.response?.data?.message);
      }
   }
};

// Get Sale Return Invoices
export const getSaleReturnInvoices = (params) => async (dispatch) => {
   try {
      dispatch({ type: 'SET_LOADING', payload: true });
      const res = await axios.get(`/sReturn-invoice/all`, { params });
      if (res.data.code === 1) {
         dispatch({
            type: GET_SALE_RETURN_INVOICES,
            payload: {
               data: res.data.data,
               pagination: res.data.pagination,
               totalCount: res.data.totalCount,
            },
         });
      }
   } catch (error) {
      if (error.response.data.message) {
         toast.error(error.response.data.message);
      }
   }
};

export const getSaleReturnInvoicesForDaybook = (params) => async (dispatch) => {
   try {
      dispatch({ type: 'SET_LOADING', payload: true });
      const res = await axios.get(`/sReturn-invoice/all`, { params });
      if (res.data.code === 1) {
         dispatch({
            type: GET_SALE_RETURN_INVOICES_FOR_DAYBOOK,
            payload: {
               data: res.data.data,
               pagination: res.data.pagination,
               totalCount: res.data.totalCount,
            },
         });
      }
   } catch (error) {
      if (error.response.data.message) {
         toast.error(error.response.data.message);
      }
   }
};

export const getSaleReturnInvoicestransactions = (params) => async (dispatch) => {
   try {
      dispatch({ type: 'SET_LOADING', payload: true });
      const res = await axios.get(`/sReturn-invoice/all`, { params });
      if (res.data.code === 1) {
         dispatch({
            type: GET_SALE_RETURN_INVOICES_TRANSACTIONS,
            payload: {
               data: res.data.data,
               pagination: res.data.pagination,
               totalCount: res.data.totalCount,
            },
         });
      }
   } catch (error) {
      if (error.response.data.message) {
         toast.error(error.response.data.message);
      }
   }
};

// Get Single Sale Return Invoice
export const getSaleReturnInvoice = (id) => async (dispatch) => {
   try {
      dispatch({ type: 'SET_LOADING', payload: true });
      const res = await axios.get(`/sReturn-invoice/${id}`);
      if (res.data.code === 1) {
         dispatch({
            type: GET_SALE_RETURN_INVOICE,
            payload: res.data.data,
            totalCount: res.data.totalCount,
         });
      }
   } catch (error) {
      if (error.response.data.message) {
         toast.error(error.response.data.message);
      }
   }
};

// Update Sale Return Invoice
export const updateSaleReturnInvoice = (data) => async (dispatch) => {
   try {
      dispatch({ type: 'SET_LOADING', payload: true });
      const res = await axios.post(`/sReturn-invoice/update`, data);
      if (res.data.code === 1) {
         dispatch({ type: UPDATE_SALE_RETURN_INVOICE, payload: res.data.data });
         setTimeout(() => {
            toast.success('Sale Return Invoice updated successfully!');
         }, 1000);
         return res.data;
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
         return res.data;
      }
      return res.data;
   } catch (error) {
      if (error.response.data.message) {
         toast.error(error.response.data.message);
      }
      return error.response.data;
   }
};

// Delete Sale Return Invoice
export const deleteSaleReturnInvoice = (id) => async (dispatch) => {
   try {
      dispatch({ type: 'SET_LOADING', payload: true });
      const res = await axios.post(`/sReturn-invoice/delete/${id}`);
      if (res.data.code === 1) {
         dispatch({ type: DELETE_SALE_RETURN_INVOICE, payload: { id } });
         setTimeout(() => {
            toast.success('Sale Return Invoice deleted successfully!');
         }, 1000);
      }
   } catch (error) {
      if (error?.response?.data?.message) {
         toast.error(error?.response?.data?.message);
      }
   }
};

// Last Bill Sale Return Invoice
export const lastBillSaleReturnInvoice = (params) => async (dispatch) => {
   try {
      const res = await axios.get(`/salesReturn/last-billNo`, {
         params,
      }); //pass Daybook ID
      if (res.data.code === 1) {
         dispatch({
            type: LAST_BILL_SALE_RETURN_INVOICE,
            payload: res.data.data,
         });
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const getLastSaleReturnDaybook = (params) => async (dispatch) => {
   try {
      // const res = await axios.get(`/salesReturn/last`, { params });
      const res = await axios.get(`/sReturn-invoice/lastDocNo`, { params });
      if (res.data.code === 1) {
         dispatch({ type: GET_LAST_SALE_RETURN_DAYBOOK, payload: res.data.data });
      }
   } catch (err) {
      console.error('getLastSaleReturnDaybook err', err);
   }
};

export const getSingleSaleReturn = (id) => async (dispatch) => {
   try {
      const res = await axios.get(`/salesReturn/${id}`);
      if (res.data.code === 1) {
         dispatch({ type: GET_ONE_SALE_RETURN, payload: res.data.data });
      }
   } catch (err) {
      console.error('Failed to get item by finish item. Please try again.');
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
   }
};

export const getSingleSalesReturnWithPrevAndNext = (params) => async (dispatch) => {
   try {
      dispatch({ type: 'SET_LOADING', payload: true });
      const res = await axios.get(`/sReturn-invoice/all`, { params });
      if (res.data.code === 1) {
         dispatch({
            type: GET_SALE_RETURN_INVOICE_WITH_PREV_AND_NEXT,
            payload: res.data,
         });
      }
   } catch (err) {
      console.error('getSaleInvoices err', err);
   }
};

export const getPrevAndNext = (params) => async (dispatch) => {
   try {
      const res = await axios.get(`/salesReturn/prev-next`, { params });
      if (res.data.code === 1) {
         dispatch({ type: GET_SALE_RETURN_INVOICE_PREV_AND_NEXT, payload: res.data.data });
      }
      return res.data.data;
   } catch (err) {
      console.error('getSaleInvoices err', err);
   }
};

export const getSalesStocks = (params) => async (dispatch) => {
   try {
      const res = await axios.get(`/salesReturn/sales-stock`, { params });
      if (res.data.code === 1) {
         dispatch({ type: GET_SALES_STOCKS, payload: res.data.data });
      }
   } catch (err) {
      console.error('getSaleInvoices err', err);
   }
};
// ======================== SALES RETURN ========================

// ======================== SALES RETURN LINE ITEM ========================

export const getSalesReturnLineItems = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/sReturn-invoice/all', { params });

      if (res.data.code === 1) {
         dispatch({ type: GET_SALE_RETURN_LINE_ITEMS, payload: res.data.data });
      }
   } catch (err) {
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
      // console.error("Failed to get Size. Please try again. :", err);
   }
};

export const addSalesReturnLineItem = (formData) => async (dispatch) => {
   try {
      const res = await axios.post('/sReturn-invoice/add', formData);

      if (res.data.code === 1) {
         dispatch({ type: ADD_SALE_RETURN_LINE_ITEM, payload: res.data.data });
         setTimeout(() => {
            toast.success('SalesLineItem added successfully!');
         }, 1000);
      }
      if (res.data.code === 0) {
         setTimeout(() => {
            toast.error(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const updateSalesReturnLineItem = (formData) => async (dispatch) => {
   try {
      const res = await axios.post(`/sReturn-invoice/update`, formData);

      if (res.data.code === 1) {
         dispatch({ type: UPDATE_SALE_RETURN_LINE_ITEM, payload: res.data.data });

         setTimeout(() => {
            toast.success('SalesLineItem updated successfully!');
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
      // toast.error("Failed to update Size. Please try again.");
   }
};

export const deleteSalesReturnLineItem = (id) => async (dispatch) => {
   try {
      if (!id) {
         toast.error('Please select any record');
         return false;
      }
      const res = await axios.post(`/sReturn-invoice/delete/${id}`);
      if (res.data.code === 1) {
         dispatch({ type: DELETE_SALE_RETURN_LINE_ITEM, payload: { id } });
         setTimeout(() => {
            toast.success('SalesLineItem deleted successfully!');
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
      // toast.error("Failed to delete Size. Please try again.");
   }
};

export const getSalesReturnLineItem = (id) => async (dispatch) => {
   const res = await axios.get(`/sReturn-invoice/${id}`);
   if (res.data.code === 1) {
      dispatch({ type: GET_SALE_RETURN_LINE_ITEMS, payload: res.data.data });
   }
   return res.data.code;
};

// ======================== SALES RETURN LINE ITEM ========================

export const emptySalesReturn = () => async (dispatch) => {
   console.log('reset...');
   dispatch({ type: EMPTY_ONE_SALE_RETURN, payload: null });
};
